import type { IconTypes } from '@/modules/perseo-billing/ui/react/src/components/beta';
import {
  Divider,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

export const Shopping = ({ authType }: { authType: string }) => {
  const isUserAuthenticated = authType === 'registered';

  return (
    <>
      <div className="co-w-full co-flex co-flex-col co-rounded-8px co-gap-16px co-py-24px co-px-16px co-border-1 co-border-[#E6E6E6] co-bg-white lg:co-py-24px lg:co-px-32px">
        <div tabIndex={0} className="co-flex co-gap-8px">
          <Icon
            icon={isUserAuthenticated ? 'ShoppingIcon' : 'RegisterIcon'}
            className="co-min-w-40px co-min-h-40px lg:co-min-w-48px lg:co-min-h-48px"
          />
          <Typography
            size="h2"
            weight="semibold"
            className="co-text-pds-neutral-900"
          >
            {isUserAuthenticated
              ? '¡Todo lo que necesitas saber está en Mis compras!'
              : '¡Ya casi eres parte de Paris.cl!'}
          </Typography>
        </div>
        <Divider />
        <div className="co-flex co-flex-col co-gap-24px">
          {!isUserAuthenticated && (
            <Typography size="h4" className="co-text-[#313131]" tabIndex={0}>
              Solo te falta crear una contraseña para registrarte y acceder a
              todos estos beneficios.
            </Typography>
          )}
          <div className="co-flex co-flex-col co-gap-8px lg:co-flex-row">
            <InfoBox
              icon="PurchaseTrackingIcon"
              label={'Conoce el estado de todas tus compras'}
            />
            <InfoBox
              icon="ProductExchangeIcon"
              label={'Pide cambios, devoluciones y reembolsos'}
            />
            <InfoBox
              icon="DownloadReceiptIcon"
              label={'Descarga tus boletas y ¡mucho más!'}
            />
          </div>
        </div>
      </div>
    </>
  );
};

interface InfoBoxProps {
  icon: IconTypes;
  label: string;
}
const InfoBox = ({ icon, label }: InfoBoxProps) => {
  return (
    <div
      tabIndex={0}
      className="co-flex co-py-16px co-px-8px co-rounded-4px co-gap-8px co-bg-pds-neutral-100 lg:co-w-1/3 lg:co-flex-col lg:co-items-center"
    >
      <Icon icon={icon} width={32} height={32} />
      <Typography size="h4" className="co-text-[#313131]">
        {label}
      </Typography>
    </div>
  );
};
